<template>
    <div class="chat-content">
        <div v-if="$route.query.type === '1'" class="article">
            <img :src="$getImageSrc($route.query.id)" alt="">
        </div>
        <div v-if="$route.query.type === '2'" class="article">
            <video
                x5-video-player-fullscreen="true"
                playsinline
                webkit-playsinline
                type="video/mp4" controls="controls">
                <source :src="$getVideoSrc($route.query.id)" type="video/mp4"/>
            </video>
        </div>
    </div>
</template>

<script>
export default {
    name: "chat-craft",
    data(){
        return {
        }
    },
}
</script>

<style scoped>
.chat-content{
    height: 100vh;
    background: #FFF;
    border-radius: 8px;
    padding: 30px;
}
img,  video {
    width: 100%;
}


</style>
